import MenuIntegracoes from "../MenuIntegracoes";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function Integracao() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/integracoes">Integrações</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Solução de problemas - Públicos personalizados do Facebook
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuIntegracoes />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Solução de problemas - Públicos personalizados do Facebook
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Integrações</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Conecte sua rede social
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Aceite os termos de públicos personalizados para habilitar o
                  carregamento do público potencial criado no módulo 'Público
                  Potencial'.
                </p>

                <p>Mensagem:</p>

                <figure>
                  <img src="img/erros-public-customized.png" alt="excel" />
                </figure>

                <figcaption>Aceite Público Personalizado</figcaption>

                <p>
                  Copie e cole em seu browser o link indicado na mensagem de
                  erro e clique em 'aceitar' os termos do Facebook. Depois crie
                  novamente a campanha para publicação.
                </p>

                <p>
                  Para evitar este erro, aceite os termos de publicos
                  personalizados do Facebook{" "}
                  <a
                    href="https://www.facebook.com/ads/manage/customaudiences/tos/"
                    target="_blank"
                  >
                    neste link
                  </a>
                  . É necessário estar logado em sua conta empresarial para
                  aceitar os termos:
                </p>

                <p>
                  Este erro também pode estar relacionado se a Meta habilitou na
                  sua conta de anúncio a feature de 'Lista de Clientes'. Só é
                  possível criar um público personalizado da lista de clientes,
                  se a conta de anúncios conectada ao Gerenciador de Negócios da
                  Meta for sua ou se você tiver permissão de administrador ou de
                  anunciante concedida pelo dono da conta. Observação: se a sua
                  conta for nova ou recentemente vinculada a uma conta
                  existente, poderá levar algumas semanas para que seja possível
                  criar ou compartilhar um público personalizado da lista de
                  clientes. Se a sua nova conta faz parte de uma conta
                  empresarial experiente, talvez você consiga fazer a
                  verificação da empresa.
                </p>

                <p>
                  Observe se na criação de público personalizado no seu
                  gerenciador de campanhas do Facebook, se a opção de 'lista de
                  clientes' está habilitada. Caso o recurso esteja indisponível,
                  veja na imagem abaixo que é necessário realizar algumas
                  campanhas até que a função seja habilitada para que a Sales
                  Box também tenha permissão de carregar público potencial em
                  sua conta de anúncios.
                </p>

                <figure>
                  <img src="img/error-import-list.png" alt="excel" />
                </figure>

                <figcaption>Recurso Indisponível Facebook</figcaption>

                <p>Veja algumas dicas do Facebook:</p>

                <p>
                  <a
                    href="https://www.facebook.com/business/help/606443329504150?id=2469097953376494 "
                    target="blank"
                  >
                    Carregar Público Potencial - Melhores Práticas
                  </a>
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
